import { useEffect, useState, memo } from "react";
import { useNavigate } from "react-router-dom";
import ROUTERS from "../../../commons/constans/router";
import MainLayout from "../../../commons/layout/MainLayout/index";

import ModalComponent from "../../../commons/components/Modal/ModalComponent"
import CheckboxComponent from "../../../commons/components/Forms/CheckboxComponent";

type Props = {
};

const IntroComponent = ({

}: Props) => {

  const navigate = useNavigate();

  const [modalStatus, setModalStatus] = useState(false);
  
  useEffect(() => {
    setTimeout(() => {
      setModalStatus(true)
    }, 3000)
  });
  
  const _handleCloseModal = () => {
    console.log('_handleCloseModal');
  }
  return (
    <MainLayout
      pageID={'intro-page'}
      activeNav={false}
      displayBottomNav={false}
    >
      <div className="logo" onClick={() => navigate(ROUTERS.LOGIN)}>
        <img src="/images/intro_logo.png" alt="" />
      </div>
      <ModalComponent
         id={"MD1"}
         show={modalStatus}
        //  heading={true}
        //  title={"영상편지 결제"}
        //  closeButton={true}
         handleClose={_handleCloseModal}
         swipeDown={false}
      >
      <div className="intro-access-modal">
        <div className="intro-access-modal__header-modal">
          <h3 className="intro-access-modal__header-modal__title">선택접근권한</h3>
          <label className="intro-access-modal__header-modal__skip">선택접근권한</label>
        </div>
        <div className="intro-access-modal__body-modal">
          <CheckboxComponent
                id={"camera"}
                name={"camera"}
                value={""}
                // handleChange={""}
                disabled={false}
                title={"카메라"}
                subTitle={"사진 촬영 및 QR코드 스캔"}
                labelClass={"d-flex align-start"}
                checked={true}
            />
            <CheckboxComponent
                id={"camera"}
                name={"camera"}
                value={""}
                // handleChange={""}
                disabled={false}
                title={"저장공간"}
                subTitle={"이미지, 임시파일 저장"}
                labelClass={"d-flex align-start"}
                checked={true}
            />
          <label className="access-notice">접근권한 설정은 ‘설정 → 접근권한’ 메뉴에서 변경 가능합니다.</label>
        </div>
        <div className="intro-access-modal__footer-modal">
            <button type="button" className="btn btn-block btn-primary btn-img" onClick={() => navigate(ROUTERS.LOGIN)}>
              동의
            </button>
        </div>
      </div>
      </ModalComponent>
    </MainLayout>
  );
};

IntroComponent.defaultProps = {
};

export default memo(IntroComponent);